import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import React,{useEffect} from 'react'
import {auth} from './firebase';
import './css/App.css';
import Header from './Header'
import Cherche from './Cherche'
import Account from './Account'
import Body from './Body'
import Int from './Int'
import Ville from './Ville'
import Login from './Login'
import Searc from './Search/Searc'
import reducer, {initialState} from "./Reducer"
import {StateProvider} from "./StateProvider"
import Addproduct from "./Addproduct"
import Product from "./Products"
import Footer from './Footer'
function App() {
  
  return (
    <Router>
      <div className="app" id="app">
        <Switch>
          <Route path="/a_vendre">
            <h1>à_vendre</h1>
          </Route>

          <Route path="/Deposer">
          <Login />
            <StateProvider initialState={initialState} reducer={reducer}>
                <Header/>
                <Addproduct/>
              </StateProvider>
          </Route>

          <Route path="/Product">
          <Login />
            <StateProvider initialState={initialState} reducer={reducer}>
              <Header/>
              <Product/>
            </StateProvider>
          </Route>
          
          <Route path="/Search">
          <Login />
            <StateProvider initialState={initialState} reducer={reducer}>
              <Header/>
              <Cherche />
              <Searc />
            </StateProvider>
            <Footer/>
          </Route>

          <Route path="/account">
            <Login />
            <StateProvider initialState={initialState} reducer={reducer}>
                <Account />
            </StateProvider>
          </Route>

          

          <Route path="/">
            
            <Login />
            <StateProvider initialState={initialState} reducer={reducer}>
              <Header/>
            </StateProvider>
            
            <div className="he">
              <h1>1er site d'annonces gratuites au Maroc</h1>
              <p>Trouver la bonne affaire parmi 1 266 844 annonces</p>
            </div>
            <Cherche/>
            <div className="ch">
              <p>Choisissez une catégorie</p>
              <p>Catégories populaires</p>
            </div>

            <Body />
            <div className="ch">
              <p>Ces annonces peuvent vous intéresser</p>
              <p>Annonces recommandées</p>
            </div>

            <Int />
            <div className="ch">
              <p>Choisissez une ville</p>
              <p>Villes populaires</p>
            </div>

            <Ville/>
            <Footer/>
          </Route>
        </Switch>
      </div>
    </Router>
    
  );
}

export default App;
